import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    stats: null,
    recentActivity: [],
}

const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        setDashboardData(state, action) {
            state.stats = action.payload.stats;
            state.recentActivity = action.payload.recentActivity;
        }
    }
});

export const { setDashboardData } = dashboardSlice.actions;

export default dashboardSlice.reducer;